import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import type { InboxFuryWebPort } from "~/api/ports";
import { InboxRouterProvider, createInboxRouter } from "./app/router";

/**
 * The application shell.
 *
 * Navigation is TanStack Router against the table in `app/routes.tsx` (kept as
 * the edge-contract catalog). Search strings (`?folder=`, `?compose=1`) stay on
 * the location so mail chrome can be query state.
 *
 * TanStack DB collections are created only after the session is authenticated,
 * so an anonymous document never calls bootstrap.
 */
export function App({
  client,
  dataMode = "server",
}: {
  client: InboxFuryWebPort;
  dataMode?: "server" | "demo";
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
      }),
  );
  const [router] = useState(() => createInboxRouter({ client, dataMode, queryClient }));

  return (
    <QueryClientProvider client={queryClient}>
      <InboxRouterProvider router={router} />
    </QueryClientProvider>
  );
}
